var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRubleIndexIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.33325C12.2091 1.33325 14 3.12411 14 5.33325C14 7.49218 12.2896 9.25163 10.15 9.33049L10 9.33325H6.66667V10.6666H9.33333C9.70152 10.6666 10 10.9651 10 11.3333C10 11.7014 9.70152 11.9999 9.33333 11.9999H6.66667V13.9999C6.66667 14.3681 6.36819 14.6666 6 14.6666C5.63181 14.6666 5.33333 14.3681 5.33333 13.9999V11.9999H2.66667C2.29848 11.9999 2 11.7014 2 11.3333C2 10.9651 2.29848 10.6666 2.66667 10.6666H5.33333V9.33325H2.66667C2.29848 9.33325 2 9.03478 2 8.66659C2 8.3247 2.25736 8.04291 2.58892 8.0044L2.66667 7.99992H5.33333V1.99992C5.33333 1.63173 5.63181 1.33325 6 1.33325H10ZM10 2.66659H6.66667V7.99992H10C11.4728 7.99992 12.6667 6.80601 12.6667 5.33325C12.6667 3.90512 11.544 2.7392 10.1331 2.66985L10 2.66659Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubleIndexIcon);
export default __webpack_public_path__ + "static/media/rubleIndexIcon.7d6ef60b.svg";
export { ForwardRef as ReactComponent };